import axios from '@/http/index';

const base = '';
// 员工请休假列表
export const getYgqxjList = (params) => axios.get(`${base}/erp/vacation/getVacationList`, params).then((res) => res.data);
// 员工请休假--统计数据
export const getYgqxjData = (params) => axios.get(`${base}/erp/vacation/getVacationMsg`, params).then((res) => res.data);
// 查询可请假的空闲员工信息
export const getUsableStaff = (params) => axios.get(`${base}/erp/vacation/getFreeTechnicains`, params).then((res) => res.data);
// 新增员工请假
export const postLeaveStaff = (params) => axios.post(`${base}/erp/vacation/saveOrUpdate`, params).then((res) => res.data);
// 获得员工请假记录
export const getLeaveList = (params) => axios.get(`${base}/erp/vacation/getTechnicianLeaveList`, params).then((res) => res.data);
// 获得员工休假记录
export const getVacationList = (params) => axios.get(`${base}/erp/vacation/getTechnicianVacationList`, params).then((res) => res.data);
// 删除请休假记录
export const getLeaveRecordDel = (params) => axios.get(`${base}/erp/vacation/delete`, params).then((res) => res.data);
// 获得出勤记录数据
export const getTechnicianWorkList = (params) => axios.get(`${base}/erp/vacation/getTechnicianWorkList`, params).then((res) => res.data);
// (今日出勤)根据时间段获得顾客预约记录数据
export const getBookOrderList4Time = (params) => axios.get(`${base}/erp/vacation/getBookOrderList4Time`, params).then((res) => res.data);
